import React, { memo, useCallback, useState } from 'react'
import { Button, Input } from 'antd'
import ImageUploader from './ImageUploader'
import { COLORS } from './utils'

const { TextArea } = Input

const PromptComposer = memo(
  ({
    isGenerating,
    onSend,
    videoId,
    aspectRatio,
    onUploadComplete
  }) => {
    const [draft, setDraft] = useState('')

    const submit = useCallback(() => {
      if (onSend(draft)) {
        setDraft('')
      }
    }, [draft, onSend])

    const handleKeyDown = useCallback(
      event => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault()
          submit()
        }
      },
      [submit]
    )

    return (
      <div
        style={{
          display: 'flex',
          gap: 12,
          alignItems: 'flex-end',
          flexWrap: 'wrap'
        }}
      >
        <div
          style={{
            flex: '1 1 280px',
            position: 'relative',
            borderRadius: 8,
            border: `1px solid ${COLORS.border}`,
            background: COLORS.white
          }}
        >
          <TextArea
            value={draft}
            onChange={event => setDraft(event.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Describe your edit..."
            disabled={isGenerating}
            style={{
              height: 42,
              minHeight: 42,
              maxHeight: 42,
              borderRadius: 8,
              padding: '10px 44px 10px 14px',
              resize: 'none',
              border: 'none',
              boxShadow: 'none',
              overflowY: 'auto'
            }}
          />
          <div
            style={{
              position: 'absolute',
              right: 8,
              bottom: 7,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <ImageUploader
              videoId={videoId}
              aspectRatio={aspectRatio}
              onUploadComplete={onUploadComplete}
              disabled={isGenerating}
              buttonStyle="ghost"
            />
          </div>
        </div>

        <Button
          type="primary"
          onClick={submit}
          loading={isGenerating}
          style={{
            height: 42,
            padding: '0 22px',
            background: COLORS.primary,
            borderColor: COLORS.primary
          }}
        >
          Send
        </Button>
      </div>
    )
  }
)

export default PromptComposer
